module.exports = __webpack_public_path__ + "img/drug-2.39b0a4fa.png";